import { inputDescLimit, inputTextLimit, radiusLimit } from '../../../helpers/inputTextLimit';
import messages from '../../../locale/messages'

const validate = values => {

  const errors = {}


  if (!values.stripePublishableKey) {
    errors.stripePublishableKey = messages.required;
  } else if (values.stripePublishableKey && values.stripePublishableKey.toString().trim() == "") {
    errors.stripePublishableKey = messages.required;
  } else if (values.stripePublishableKey.length > inputTextLimit) {
    errors.stripePublishableKey = messages.inputFieldLimitError;
  }

  if (!values.stripeSecretKey) {
    errors.stripeSecretKey = messages.required;
  } else if (values.stripeSecretKey && values.stripeSecretKey.toString().trim() == "") {
    errors.stripeSecretKey = messages.required;
  } else if (values.stripeSecretKey.length > inputTextLimit) {
    errors.stripeSecretKey = messages.inputFieldLimitError;
  }

  if (!values.twillioAccountSid) {
    errors.twillioAccountSid = messages.required;
  } else if (values.twillioAccountSid && values.twillioAccountSid.toString().trim() == "") {
    errors.twillioAccountSid = messages.required;
  } else if (values.twillioAccountSid.length > inputTextLimit) {
    errors.twillioAccountSid = messages.inputFieldLimitError;
  }

  if (!values.twillioPhone) {
    errors.twillioPhone = messages.required;
  } else if (values.twillioPhone && values.twillioPhone.toString().trim() == "") {
    errors.twillioPhone = messages.required;
  } else if (values.twillioPhone.length > inputTextLimit) {
    errors.twillioPhone = messages.inputFieldLimitError;
  }

  if (!values.twillioAuthToken) {
    errors.twillioAuthToken = messages.required;
  } else if (values.twillioAuthToken && values.twillioAuthToken.toString().trim() == "") {
    errors.twillioAuthToken = messages.required;
  } else if (values.twillioAuthToken.length > inputTextLimit) {
    errors.twillioAuthToken = messages.inputFieldLimitError;
  }

  if (!values.maxDistance) {
    errors.maxDistance = messages.required;
  } else if (values.maxDistance && values.maxDistance.toString().trim() == "") {
    errors.maxDistance = messages.required;
  } else if (isNaN(values.maxDistance)) {
    errors.maxDistance = messages.numericValue;
  } else if (values.maxDistance.length > radiusLimit) {
    errors.maxDistance = messages.fifteenNumbersAllowed;
  }

  if (!values.fcmPushNotificationKey) {
    errors.fcmPushNotificationKey = messages.required;
  } else if (values.fcmPushNotificationKey && values.fcmPushNotificationKey.toString().trim() == "") {
    errors.fcmPushNotificationKey = messages.required;
  } else if (values.fcmPushNotificationKey.length > inputDescLimit) {
    errors.fcmPushNotificationKey = messages.inputDescLimitError;
  }

  if (!values.paystackSecretKey) {
    errors.paystackSecretKey = messages.required;
  } else if (values.paystackSecretKey && values.paystackSecretKey.toString().trim() == "") {
    errors.paystackSecretKey = messages.required;
  } else if (values.paystackSecretKey.length > inputTextLimit) {
    errors.paystackSecretKey = messages.inputFieldLimitError;
  }

  if (values.riderCashbackPercentage === undefined || values.riderCashbackPercentage === null || values.riderCashbackPercentage.toString().trim() === "") {
    errors.riderCashbackPercentage = messages.required;
  } else if (isNaN(values.riderCashbackPercentage)) {
    errors.riderCashbackPercentage = messages.numericValue;
  } else if (!/^\d+$/.test(values.riderCashbackPercentage.toString().trim())) {
    errors.riderCashbackPercentage = messages.integerOnly;
  } else {
    const n = parseInt(values.riderCashbackPercentage, 10);
    if (n < 0 || n > 100) {
      errors.riderCashbackPercentage = messages.rangeZeroToHundred;
    }
  }

  return errors
}

export default validate;
